module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-34.8af3a5fc.jpg";